const baseBlockquoteData = { indentation: 0 };
export const BlockquoteData = {
    fromJSON(object) {
        const message = Object.assign({}, baseBlockquoteData);
        message.indentation =
            object.indentation !== undefined && object.indentation !== null
                ? Number(object.indentation)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.indentation !== undefined && (obj.indentation = Math.round(message.indentation));
        return obj;
    },
};
//# sourceMappingURL=node_blockquote.js.map